module.exports = __webpack_public_path__ + "img/no_report.7f93b3ad.png";